module.exports = __webpack_public_path__ + "img/syria.2f694001.svg";